import { CollegeRecommend } from "@/pages/SchoolDiagnoseReport/type";

export const GRADE_LIST = ["", "高一", "高二", "高三"];

const SN = "dd1f8fdf-d061-4dfa-86d6-a1a184f09952";
